import { useState, useEffect, Fragment } from "react";
import FleetWebApi from "../Api/FleetWebApi";
import CircularProgress from "@mui/material/CircularProgress";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { NavLink } from "react-router-dom";
import proxiableDevices from "../Configuration/ProxiableDevices";
import cellularTypes from "../Configuration/CellularTypes";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

function ProxyConsoleLink({ coreID }) {
  const [slug, setSlug] = useState(null);
  useEffect(() => {
    let mounted = true;
    FleetWebApi.getProductSlug(coreID)
      .then((response) => {
        if (mounted) setSlug(response);
      })
      .catch(() => {
        if (mounted) setSlug(null);
      });
    return () => {
      mounted = false;
    };
  }, [coreID]);
  // If no valid product slug, this is not a particle device; do not render particle link
  if (!slug) return null;
  const href = `https://console.particle.io/${slug}/devices/${coreID}`;
  return (
    <Tooltip title="Particle" arrow placement="top">
      <IconButton
        size="small"
        style={{ marginLeft: 8 }}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open in Particle Console"
      >
        <img src="/particle_logo.png" alt="Particle" style={{ width: 16, height: 16, display: "block" }} />
      </IconButton>
    </Tooltip>
  );
}

function Proxies(props) {
  const [proxies, setProxies] = useState({ allProxies: [], recentProxies: [] });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    let isMounted = true;
    if (proxiableDevices.includes(props.type)) {
      setIsLoading(true);
      FleetWebApi.getProxies(props.coreId, "noncellular_device")
        .then((response) => {
          if (isMounted) {
            setProxies(response);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          if (isMounted) {
            setError(error.message);
            setIsLoading(false);
          }
        });
    } else if (cellularTypes.includes(props.type)) {
      setIsLoading(true);
      FleetWebApi.getProxies(props.coreId, "cellular_device")
        .then((response) => {
          if (isMounted) {
            setProxies(response);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          if (isMounted) {
            setError(error.message);
            setIsLoading(false);
          }
        });
    } else {
      // Unknown device type: nothing to fetch, so don't leave the spinner running
      setIsLoading(false);
    }
    return () => {
      isMounted = false;
      setProxies({ allProxies: [], recentProxies: [] });
    };
  }, [props.coreId, props.type]);

  return (
    <Fragment>
      <TableRow>
        <TableCell component="th" scope="row">
          {proxiableDevices.includes(props.type)
            ? "Recent Proxies (last day)"
            : "Recently Proxied Through (last day)"}
        </TableCell>
        <TableCell
          data-th={
            proxiableDevices.includes(props.type)
              ? "Recent Proxies (last day)"
              : "Recently Proxied Through (last day)"
          }
        >
          {isLoading && <CircularProgress color="secondary" />}
          {error && <p>Error Loading Data: {error}</p>}
          {proxies.recentProxies.map((proxy, key) => (
            <Fragment key={key}>
              <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{ minWidth: '120px', display: 'inline-block' }}>
                  {proxy.serialNumber}
                </span>
                <NavLink to={"/device/" + proxy.coreID} className="Nav_link">
                  {proxy.coreID}
                </NavLink>
                <ProxyConsoleLink coreID={proxy.coreID} />
              </div>
            </Fragment>
          ))}
        </TableCell>
      </TableRow>
      {proxiableDevices.includes(props.type) ? (
        <TableRow>
          <TableCell component="th" scope="row">
            All Proxies (last 30 days)
          </TableCell>
          <TableCell data-th="All Proxies (Last 30 Days)">
            {isLoading && <CircularProgress color="secondary" />}
            {error && <p>Error Loading Data: {error}</p>}
            {proxies.allProxies.map((proxy, key) => (
              <Fragment key={key}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                  <span style={{ minWidth: '120px', display: 'inline-block' }}>
                    {proxy.serialNumber}
                  </span>
                  <NavLink to={"/device/" + proxy.coreID} className="Nav_link">
                    {proxy.coreID}
                  </NavLink>
                    <ProxyConsoleLink coreID={proxy.coreID} />
                </div>
              </Fragment>
            ))}
          </TableCell>
        </TableRow>
      ) : null}
    </Fragment>
  );
}

export default Proxies;
